import React from "react";
import '../css/photo.css';

export default function Photo(props) {

  const showDate = props.showDate

  const setImageAsThis = (e) => {
    props.selectImage(props.data, props.index, props.tag)
  }

  return (
    //ideally make thumbnails one day so it loads faster

    <div className="card transparent">
      <img className="card-img" src={props.data.src} alt={props.data.title} onClick={setImageAsThis}/>
      <p>{props.data.title}<br />
        {showDate && props.data.date}</p>
    </div>
  );
}
